import React, { useEffect, useState } from 'react';
import { Row, Col, message, Spin, Space, Button, Typography, Form, Empty } from 'antd';
import ListCard from 'Molecules/ListCard';
import HeadingChip from 'Molecules/HeadingChip';
import { useDispatch, useSelector } from 'react-redux';
import { getAlacartes } from '../../../../../ducks/actions'
import { bulkRemoveAlacartes } from '../../../../../ducks/services'
import { Popup } from 'Atoms/Popup';
import { LoadingOutlined } from '@ant-design/icons';
import { SelectField, InputField } from 'Atoms/FormElement';
import { useForm } from 'react-hook-form';
import { useTranslate } from 'Translate';

const antIcon = <LoadingOutlined spin />;
const { Title } = Typography;

export default (props) => {
  const dispatch = useDispatch();
  const { id, meta, activeTab, allowedEdit } = props;
  const { control, formState: { errors }, handleSubmit, setValue, getValues } = useForm();
  const alacartes = useSelector((state) => state.product.alacartes);
  const [page, setPage] = useState(1);
  const [limit, setLimit] = useState(25);
  const [selectedRowKeys, setSelectedRowKeys] = useState([]);
  const [bulkRemoveVisible, setBulkRemoveVisible] = useState(false);
  const [load, setLoad] = useState(false);
  const i18n = useTranslate();
  const { t } = i18n;

  const colName = [
    {
      title: t("Outlet.product_code"),
      dataIndex: 'code',
      key: 'code',
      sorter: true
    },
    {
      title: t("Product.product_name"),
      dataIndex: 'name',
      key: 'name',
      sorter: true
    },
  ];

  const btnList = [
    {
      title: t("Product.confirm_change_ing_select_alacarte"),
      text: t("Product.change_ing"),
      classes: 'red-btn text-white attendance-success',
      btnHidden: selectedRowKeys.length <= 0,
      action: () => {
        setBulkRemoveVisible(true);
        setValue('ingredient', null);
      }
    }
  ];

  useEffect(() => {
    if (activeTab === "3")
      dispatch(getAlacartes(1, limit, '', '', props.setLoading, id));
  }, [activeTab]);

  const onTableChange = (pagination, filters, sorter) => {
    setPage(pagination.current);
    setLimit(pagination.pageSize);
    if (sorter.order) {
      dispatch(getAlacartes(pagination.current, pagination.pageSize, sorter.order, sorter.columnKey, props.setLoading, id));
    } else {
      dispatch(getAlacartes(pagination.current, pagination.pageSize, '', '', props.setLoading, id));
    }
  }

  const onSelectChange = (newSelectedRowKeys) => {
    setSelectedRowKeys(newSelectedRowKeys);
  };

  const rowSelection = {
    selectedRowKeys,
    onChange: onSelectChange,
  };

  const onBulkRemove = async (val) => {
    setLoad(true);

    const payload = {
      id: id,
      ingredient_id: val?.ingredient?.value,
      // uom_id: val?.uom?.value,
      qty: val?.quantity,
      alacartes: JSON.stringify(selectedRowKeys)
    }

    await bulkRemoveAlacartes(payload).then(res => {
      setLoad(false);
      if (res.data.code === 200) {
        rowSelection.onChange([]);
        setBulkRemoveVisible(false);
        message.success(t("Product.success_change_ing_select_alacarte"));
        setTimeout(() => dispatch(getAlacartes(1, limit, '', '', props.setLoading, id)), 500);
      }else{
        message.error(res.data.message);
      }
    }).catch(e => {
      setLoad(false);
      message.error(e.message ?? t("General.something_went_wrong"));
    })
  }

  const popup2 = {
    closable: false,
    visibility: bulkRemoveVisible,
    content: <Spin indicator={antIcon} size="large" spinning={load}>
      <Form layout="vertical" onFinish={handleSubmit(onBulkRemove)}>
        <Space direction='vertical' size={15} className='w-100'>
          <Title level={4} className='m-0'>
            {t("Product.change_ing")}
          </Title>
          <SelectField
            isRequired={bulkRemoveVisible}
            fieldname='ingredient'
            label={t("General.ing")}
            class='mb-0 w-100 default-select'
            initValue={''}
            control={control}
            iProps={{ placeholder: t("General.please_select"), isDisabled: !allowedEdit }}
            selectOption={meta?.ingredients?.map(x => ({ label: `${x.code} ${x.name}`, value: x.id }))}
            rules={{
              required: bulkRemoveVisible ? t("Product.ing_req") : false,
            }}
            validate={errors.ingredient && 'error'}
            validMessage={errors.ingredient && errors.ingredient.message}
          />
          <div>
            <InputField
              // isRequired={bulkRemoveVisible}
              fieldname='quantity'
              label={t("General.qty")}
              class='mb-0 w-100'
              initValue={''}
              control={control}
              iProps={{ placeholder: t("General.pls_enter_qty"), type: 'number', disabled: !allowedEdit }}
              rules={{
                // required: bulkRemoveVisible ? 'Quantity is required' : false,
                pattern: { value: /^[1-9]\d*(\.\d+)?$/, message: t("General.only_valid_num_allow") }
              }}
              validate={errors.quantity && 'error'}
              validMessage={errors.quantity && errors.quantity.message}
            />
            <span className='c-gray'>{t("Product.enter_0_or_blank_unchange")}</span>
          </div>
          <Row gutter={10}>
            <Col span={12}><Button size='large' danger type="primary" className='w-100' onClick={() => setBulkRemoveVisible(false)}>{t("General.cancel")}</Button></Col>
            {
              allowedEdit &&
              <Col span={12}><Button size='large' type="primary" className='green-btn w-100' htmlType='submit'>{t("General.confirm")}</Button></Col>
            }
          </Row>
        </Space>
      </Form>
    </Spin>,
    width: 536,
    onCancel: () => {
      setBulkRemoveVisible(false);
    },
  };

  return (
    <>
      <Row gutter={[10, 10]}>
        <Col span={24}>
          <HeadingChip title={""} btnList={allowedEdit ? btnList : null} />
        </Col>
        <Col span={24} className="clickRow">
          <ListCard
            listClass="nopad"
            ListData={alacartes?.list?.map(x => ({ ...x, key: x.id }))}
            onChange={onTableChange}
            ListCol={colName}
            rowSelection={allowedEdit && rowSelection}
            pagination={{
              total: alacartes?.total_count,
              current: page,
              pageSize: limit
            }}
          />
        </Col>
      </Row>
      <Popup {...popup2} />
    </>
  )
}